<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="main-content-area">
                <div class="row">
                    <div class="col-md-12">
                        <h3 class="box-title">404 - Página não encontrada</h3>
                    </div>
                </div>
                <center>
                    <figure>
                        <img src="/assets/images/not_found.jpg" alt="Página não encontrada">
                    </figure>
                </center>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'notFound'
}
</script>

